import { render, staticRenderFns } from "./sightingsloc.vue?vue&type=template&id=1669d572&"
import script from "./sightingsloc.vue?vue&type=script&lang=js&"
export * from "./sightingsloc.vue?vue&type=script&lang=js&"
import style0 from "./sightingsloc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports